require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-ivano-gianola.json") })
        }
      }, "path---en-interviste-ivano-gianola");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-ivano-gianola!./.cache/json/en-interviste-ivano-gianola.json
// module id = 584
// module chunks = 231608221292675